import React from "react";
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components";

import Layout from "../layouts/layout.js";
import Seo from "../components/seo.js";
import SectionBottomCta from "../components/SectionBottomCta.js";

import { Wrapper, SectionH2, SectionParag, Section1ColWhite } from "../styles/style.js";

const BigButton = styled(Link)`
  display: block;
  background-color: orange;
  color: #fff;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: 400;
  text-align: center;
  letter-spacing: 1px;
  padding: 15px 20px;
  border-radius: 3px;
  margin-top: 25px;
  margin-left: auto;
  margin-right: auto;
  max-width: 250px;
`;

const SmallButton = styled(BigButton)`
  padding: 10px 15px;
  max-width: 200px;
  background-color: gray;
`;

const FleetEscaladePage = () => (
  <Layout>
    <Seo
      title="Escalade Limo"
    />

    <Section1ColWhite>
      <Wrapper>
        <StaticImage src="../img/fleet-champagne-escalade.png" alt="escalade limo" />
        <SectionH2>Escalade Limo</SectionH2>
        <SectionParag>
          Sophisticated and spacious. Outfitted with fine materials and top level amenities. Passengers can really take advantage of the ample room and relax.
        </SectionParag>
        <SectionParag>Capacity: 18 Passengers</SectionParag>
        <BigButton to="/quote">Request Free Quote</BigButton>
        <SmallButton to="/fleet">View Fleet</SmallButton>
      </Wrapper>
    </Section1ColWhite>

    <SectionBottomCta grayBackground />
  </Layout>
);

export default FleetEscaladePage